import { Injectable } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ServiceBase } from './servicebase.service';
import { ExportsData } from '../shared/models/exports-data-model';
import * as moment from 'moment';
import { HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ExportsService extends ServiceBase {
  public generateExportData(exportsData: ExportsData): Observable<number> {
    let options = Object.assign({}, this.httpOptions, {
      params: {
        'exportTypeId': exportsData.exportTypeId,
        'startDate': moment(exportsData.filterValues.startDate).format('MM/DD/YYYY'),
        'endDate': moment(exportsData.filterValues.endDate).format('MM/DD/YYYY'),
        'cgicCode': exportsData.filterValues.cgicCode
      }
    });
    return this.http.get<number>(`${this.apiRoot}/api/Export/GenerateExportData`, options)
      .pipe(catchError(this.swallowError<any>('generateExportData', 'defaultMsg', null, null))); 
  }

  public getAllExportTypes(): Observable<ServerModels.ENESS_REF_ExportTypes[]> {
    return this.http.get<ServerModels.ENESS_REF_ExportTypes[]>(`${this.apiRoot}/api/Export/GetAllExportTypes`, this.httpOptions)
      .pipe(catchError(this.swallowError<any>('getAllExportTypes', 'defaultMsg', null, null))); 
  }

  public getExportDataById(exportId: string, fileName: string): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.apiRoot}/api/Export/GetExportDataById`, {
      observe: "response",
      responseType: 'blob',
      params: {
        'exportId': exportId,
        'filename': fileName
        }
      })
      .pipe(catchError(this.swallowError<any>('getExportDataById', 'defaultMsg', null, null))); 
  }

  public getExportDataByUser(): Observable<ServerModels.ENESS_Exports[]> {
    return this.http.get<ServerModels.ENESS_Exports[]>(`${this.apiRoot}/api/Export/GetExportDataByUser`, this.httpNoCache)
      .pipe(catchError(this.throwError<any>('getExportDataByUser', null, null, null))); 
  }

  public getAgencyCDSMouExport(filterModel: ServerModels.FiltersViewModel): Observable<ServerModels.ENESS_Exports> {
    return this.http.post<ServerModels.ENESS_Exports>(`${this.apiRoot}/api/Export/GetAgencyCDSMouExport`, filterModel, this.httpOptions)
      .pipe(catchError(this.throwError<any>('getAgencyCDSMouExport', 'defaultMsg', null, null)));
  }
}
